var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-wrap"},[_c('div',{staticClass:"overflow-bg"},[_c('BgWave')],1),_c('div',{staticClass:"learn-more"},[_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t("contact.title")))]),_c('div',{staticClass:"button"},[_c('div',{staticClass:"apply button-box2"},[_vm._v(" "+_vm._s(_vm.$t("contact.btn"))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }